import React from "react";
import { Helmet } from "react-helmet";
import HeaderDefault from "../../../components/header/HeaderDefault";
import CopyRight from "../../../components/footer/copyright/CopyRight";
import Footer from "../../../components/footer/Footer";
import ServiceList from "../../../components/list/ServiceList";
import ServiceFaq from "../../../components/faq/ServiceFaq";
import Skills from "../../../components/skill/Skills";
import SoftwareConsultingApproach from "../../../components/service/SoftwareConsultingApproach";
import CounterThree from "../../../components/counter/CounterThree";
import SoftwareConsultingFeatures from "../../../components/service/SoftwareConsultingFeatures";
import ImageGridThree from "../../../components/image-grid/ImageGridThree";

const ConsultingService = () => {
    return (
        <div>
            <Helmet>
                <title>Multi Cloud Ai - Software Devlopment Consulting</title>
            </Helmet>
            {/* End Page SEO Content */}

            <HeaderDefault />
            {/* End Header */}

            <div className="ptf-main">
                <div className="ptf-page ptf-page--service-detail">
                    <section>

                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-9">
                                    {/* <!--Animated Block--> */}

                                </div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <h1 className="large-heading2 text-center"
                                    >Software Development Consulting With Multi Cloud Ai</h1>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We at Multi Cloud Ai offer an innovative and holistic approach to
                                        product development, creativity & management and top notch
                                        qualities that can assist you to make right decisions.
                                        Predominantly, our area of expertise is building custom
                                        software solutions, handling cloud consulting, software
                                        testing, IT Consulting Strategy, Technological Roadmap,
                                        custom software development and Business Intelligence. </p>

                                    <ImageGridThree />

                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>SOFTWARE CONSULTING</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        With immense experience, we deliver a broad range of
                                        consulting services entails a comprehensive analysis of your
                                        existing system, mapping out your plan on the introduction
                                        of new components, and guiding you in the complex software
                                        world.
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.5rem" }}
                                        ></div>
                                        It is imperative to outline the right solution that is
                                        flexible, reliable and cost-effective and perfectly
                                        attributed to your business objectives and IT strategy. We
                                        emphasize the size of your business, the objectives you
                                        pursue, tasks you want to carry out, challenges you confront
                                        and assist you to save money, generate revenue and
                                        streamline your business growth with wisely considered
                                        software solutions.
                                    </p>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem" }}
                                    ></div>
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>CLOUD CONSULTING</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.5rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            Multi Cloud Ai experienced cloud consultants offer uncountable
                                            benefits that help in creating the right cloud strategy
                                            associated with your business objectives. We provide cloud
                                            consulting services for the development of high-quality web
                                            applications with a rich and elegant user interface and
                                            highly loaded services that are able to manage a large
                                            volume of requests from users. Also, we help modernize your
                                            applications through leveraging the power of the cloud which
                                            includes cloud applications modernization, cloud environment
                                            support, continuous integration and delivery, cloud testing
                                            and QA Automation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5rem" }}
                        ></div>
                        <div
                            className="ptf-animated-block"
                            data-aos="fade"
                            data-aos-delay="0"
                        >
                            {/* <!--Spacer--> */}
                            <div
                                className="ptf-spacer"
                                style={{ "--ptf-xxl": "1rem", "--ptf-md": "1rem" }}
                            ></div>
                            <div className="fz-18 my_background"
                                style={{ marginLeft: "20px" }}
                            >
                                <h4>Our Value Driven Approach to Software Development</h4>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "1rem", "--ptf-md": "1rem" }}
                                ></div>
                                <ul>
                                    <li>Research and Business Analysis.</li>
                                    <li>Recommendations on
                                        Technology Selection</li>
                                    <li>Mindset to offer reliable and
                                        long-lasting solutions.</li>
                                    <li>Aspiration on high ROI and clear
                                        business objectives</li>
                                    <li>Quick delivery of the first software
                                        version and iterative development further.</li>
                                    <li>Execution of
                                        DevOps practices (IaC, automated configurations and
                                        testing, continuous integration (CI) and continuous
                                        delivery (CD)) to offer quick and frequently, provide
                                        clean and reliable code, and simplify deployment.</li>
                                    <li>Priority creating a vigorous trust level and harmonious relationship with our customers.</li>
                                    <li>Secure your software from security risks.</li>
                                    <li>Ensure quality of Software</li>
                                </ul>
                            </div>
                        </div>
                    </section>
                    {/* Top Portion */}

                    {/* <!--Spacer--> */}
                    <div className="ptf-spacer" style={{ "--ptf-xxl": "5rem" }}></div>

                    <section
                        className="has-accent-1-background"
                        style={{
                            backgroundImage: `url("/assets/img/root/service-bubble.png")`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "100% calc(100% + 120px)",
                        }}
                    >
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                        ></div>
                        <div className="container-xxl">
                            {/* <!--Animated Block--> */}
                            <div
                                className="ptf-animated-block"
                                data-aos="fade"
                                data-aos-delay="0"
                            >
                                <h1 className="has-white-color large-heading">Consulting Services</h1>
                            </div>
                            {/* <!--Spacer--> */}
                            <div
                                className="ptf-spacer"
                                style={{ "--ptf-xxl": "7.5rem", "--ptf-md": " 3.75rem" }}
                            ></div>
                            <SoftwareConsultingApproach />
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
                        ></div>
                    </section>
                    <section>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5.625rem", "--ptf-md": "2.8125rem" }}
                        ></div>
                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-8">

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.125rem" }}
                                    ></div>
                                    <div
                                        className="row"
                                        style={{
                                            "--bs-gutter-x": "3.75rem",
                                            "--bs-gutter-y": "7.5rem",
                                        }}
                                    >
                                        <CounterThree />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h3>Our Skills</h3>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.75rem" }}
                                    ></div>
                                    <div className="ptf-skill-box-grid">
                                        <Skills />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>Feature We Are Providing</h2>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5.625rem" }}
                                    ></div>
                                    {/* <!--Process Steps--> */}
                                    <SoftwareConsultingFeatures />
                                </div>
                                <div className="col-xl-4">
                                    <div className="ptf-sidebar ptf-sidebar--right">
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-services-list">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">Services List</h4>
                                                <ServiceList />
                                            </div>
                                        </div>
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-faq">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">FAQs</h4>
                                                <ServiceFaq />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "6.25rem", "--ptf-md": "3.125rem" }}
                        ></div>
                    </section>
                    {/* End .main content with sidebar */}
                </div>
                {/* End .ptf-page */}
            </div>
            {/* End ptf-main */}

            {/*=============================================
            Start Footer
            ============================================== */}
            <footer className="ptf-footer ptf-footer--style-1">
                <div className="container-xxl">
                    <div className="ptf-footer__top">
                        <Footer />
                    </div>
                    <div className="ptf-footer__bottom">
                        <CopyRight />
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default ConsultingService